module.exports = __webpack_public_path__ + "static/img/logo-full.d3b6f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/assets/logo-full.png
// module id = ERdk
// module chunks = 1